import React, {useEffect, useRef, useState} from "react";
import Tags from "react-tag-autocomplete";
import classes from "./styles.module.css";

function PayoutsDetailTags({tags: propTags = [], suggestionsTags = [], onSelectedTag}) {
    const [tags, setTags] = useState(propTags);
    const reactTagsRef = useRef();

    useEffect(() => {
        setTags(propTags);
    }, [propTags]);

    useEffect(() => {
        if (onSelectedTag) onSelectedTag(tags);
    }, [tags, onSelectedTag]);

    function handleDelete(i) {
        const newTags = tags.slice(0);
        newTags.splice(i, 1);
        setTags(newTags);
    }

    function handleAddition(tag) {
        const newTags = [...tags, tag];
        setTags(newTags);
    }

    return (
        <Tags
            ref={reactTagsRef}
            tags={tags}
            suggestions={suggestionsTags}
            handleDelete={handleDelete}
            handleAddition={handleAddition}
            allowNew={true}
            autoresize={false}
            placeholder={"Добавить метку"}
            noSuggestionsText={"Меток не найдено"}
            addOnBlur={true}
            minQueryLength={1}
            classNames={{
                root: classes.Wrap,
                rootFocused: classes.isFocused,
                selected: classes.Selected,
                selectedTag: classes.SelectedTag,
                selectedTagName: "react-tags__selected-tag-name",
                search: classes.TagSearchWrap,
                searchInput: classes.Input,
                suggestions: classes.Suggestions,
                suggestionActive: "is-active",
                suggestionDisabled: "is-disabled",
            }}
        />
    );
}

export default PayoutsDetailTags;


// WEBPACK FOOTER //
// ./src/Components/PayoutsDetailTags/index.js